import React from 'react';
import { MessageCircle, ArrowRight } from 'lucide-react';
import { usePopup } from '../context/PopupContext';

const FloatingCTA: React.FC = () => {
    const { openPopup } = usePopup();

    return (
        <button
            onClick={() => openPopup()}
            className="group relative flex items-center gap-3 bg-secondary hover:bg-secondary-600 text-white pl-6 pr-8 py-4 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-105 animate-fade-in border-2 border-white/20"
        >
            {/* Blinking Arrow Indicator */}
            <div className="absolute -left-3 top-1/2 -translate-y-1/2 flex">
                <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md animate-pulse">
                    <ArrowRight className="w-5 h-5 text-secondary" />
                </div>
            </div>

            <div className="flex flex-col items-start ml-4">
                <span className="text-xs font-medium text-white/80 uppercase tracking-wider">Get in Touch</span>
                <div className="flex items-center gap-2">
                    <span className="font-bold text-lg tracking-wide">Enquire Now</span>
                </div>
            </div>

            <MessageCircle className="w-6 h-6 fill-current opacity-80 group-hover:opacity-100 transition-opacity" />
        </button>
    );
};

export default FloatingCTA;
